import classNames from "classnames"
import TileIcon from "./TileIcon"

export default function TileTypeSections({ sections, selectTileHandler }) {
  return (
    <div className="flex flex-col overflow-y-auto rounded-sm bg-neutral-10 p-4 shadow-inner">
      {sections.map(
        (section, index) =>
          !!section.tiles.length && (
            <div key={index} className="mt-5 first:mt-0">
              {section.description && (
                <h3
                  className={classNames(
                    "px-3 text-xs font-medium uppercase tracking-wider text-gray-500"
                  )}
                >
                  {section.description}
                </h3>
              )}
              <ul className="grid grid-cols-3 gap-4 rounded-sm bg-neutral-10 py-2">
                {section.tiles.map((tile) => (
                  <li
                    onClick={() => selectTileHandler(tile)}
                    key={tile.key}
                    className="group flex h-16 cursor-pointer items-center rounded-md bg-white p-4 shadow-md hover:bg-primary-10"
                  >
                    <div className="flex-auto font-medium group-hover:text-primary-4">
                      {tile.label}
                    </div>
                    <div>
                      <TileIcon icon={tile.icon} label={tile.label} />
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          )
      )}
    </div>
  )
}
